gsap.registerPlugin(ScrollTrigger);

gsap.to('.text-with-boards--image-media.image_one_motion img', {
  yPercent: 10,
  ease: 'linear',
  scrollTrigger: {
    trigger: '.text-with-boards',
    scrub: 1,
    start: 'top bottom',
    end: 'bottom top'
  }
})

gsap.to('.text-with-boards--image-media.image_two_motion img', {
  yPercent: -10,
  ease: 'none',
  scrollTrigger: {
    trigger: '.text-with-boards',
    scrub: 1,
    start: 'top bottom',
    end: 'bottom top'
  }
})


gsap.to('.text-with-boards--image-media.image_three_motion img', {
  yPercent: 5,
  ease: 'none',
  scrollTrigger: {
    trigger: '.text-with-boards',
    scrub: 1,
    start: 'top bottom',
    end: 'bottom top'
  }
})

gsap.to('.text-with-boards--image-media.image_four_motion img', {
  yPercent: -5,
  ease: 'none',
  scrollTrigger: {
    trigger: '.text-with-boards',
    scrub: 1,
    start: 'top bottom',
    end: 'bottom top'
  }
})

